import React from "react";
import { Table } from "semantic-ui-react";
import { addCommas } from "utils/numbers";

export default ({ row_bookings, row }) => {
  const reducer = (a, c) => a + Number(c.calculated.owner_pay);
  const total = row_bookings.reduce(reducer, 0);
  return <Table.Cell>${addCommas(total, 2)}</Table.Cell>;
};
